import { IS_LIVE } from './app';

export const ONE_MONTH_CARE_ONLY_PP = 'wm-one-month-149';

export const BUNDLE_WEGOVY_CENTERWELL_INJECTION_THREE_MONTH_PRICE_POINT =
  'bundle-wegovy-centerwell-injection-3-month-1317';

export const BACK_TO_WM_PRICE_POINTS = ['wm-one-month-149', 'wm-six-months-894'];

export const WM_VALID_ONBOARDING_PRICE_POINTS_FOR_PARTNER_FLOWS = [
  'wm-one-month-129',
  'wm-three-months-129',
  'wm-six-months-129',
  'wm-twelve-months-129'
];

export const WM_NEW_VALID_ONBOARDING_PRICE_POINTS = [
  'wm-one-month-149',
  'wm-three-months-447',
  'wm-six-months-894',
  'wm-twelve-months-1788',
  ...(!IS_LIVE ? [BUNDLE_WEGOVY_CENTERWELL_INJECTION_THREE_MONTH_PRICE_POINT] : [])
];

// Stardust intro promo ($39 trial-start) price points — patients sign up
// externally and must hit the post-onboarding medication selection page
// (PO/BenefitsCheck). They should NOT appear in /sign-up plan selectors.
// They ARE eligible for the medication options shown on that page,
// including the compounded GLP-1 card when the patient is clinically
// eligible (see defineIfPatientIsEligibleForCompound in utils/mif).
export const WM_INTRO_PROMO_PRICE_POINTS = [
  'wm-membership-monthly-149-intro-39',
  'wm-membership-3mo-297-intro-39',
  'wm-membership-6mo-534-intro-39',
  'wm-membership-annual-888-intro-39'
];

export const WM_SEMAGLUTIDE_MIGRATION_PRICE_POINTS = [
  'wm-one-month-149',
  'wm-three-months',
  'wm-six-months-894',
  'wm-twelve-months-1788'
];

export const WM_BALLAD_HEALTH_PRICE_POINTS = ['wm-one-month-149', 'wm-three-months-447'];

export const WM_ONBOARDING_PRICE_POINTS_SPECIFIC_FLOW = ['wm-one-month-vip-29'];

export const TT_WM_ONE_MONTH_PRICE_POINT = 'wm-tt-one-month';

export const TRIPLE_THERAPY_PRICE_POINTS = [TT_WM_ONE_MONTH_PRICE_POINT, 'one-month-tt'];

// to show one or few pp during onboarding
export const WM_INSURANCE_VALID_ONBOARDING_PRICE_POINTS = ['wm-insurance-one-month-0'];

// The `categories` value the backend treats as authoritative for insurance classification
// (`PRICE_POINT_CATEGORIES.INSURANCE` in `usingInsuranceOrCashPayResolver`). Keying off the same
// field is what stops client and server quietly disagreeing.
export const PRICE_POINT_CATEGORY_INSURANCE = 'insurance';

// to define if authorized user is insurance user
export const WM_INSURANCE_VALID_PRICE_POINTS = [
  'wm-insurance-one-month',
  'wm-insurance-one-month-0',
  'wm-insurance-one-month-trial',
  'wm-insurance-one-month-19'
];

export const BLUE_LINE_ONBOARDING_PRICE_POINTS = ['wm-bl'];

export const WM_INSURANCE_ALT_VALID_PRICE_POINTS = ['wm-insurance-one-month-19'];

export const TIRZEPATIDE_PRICE_POINT = 'bundle-tirzepatide-one-month';

export const SEMAGLUTIDE_PRICE_POINT = 'bundle-semaglutide-one-month-399';

export const BUNDLE_SEMAGLUTIDE_PRICE_POINT = 'bundle-semaglutide-one-month';

export const BUNDLE_WEGOVY_ONE_MONTH_PRICE_POINT = 'bundle-wegovy-one-month-399';

export const BUNDLE_WEGOVY_PILL_PRICE_POINT = 'bundle-wegovypill-one-month-349';

// Weight-management price points that must route the patient through the
// post-onboarding preferred-medication selection widget (the PO
// `preferred-medication` step and the Alt `BenefitsCheck` step). Patients on
// these plans sign up without a locked-in medication, so the widget has to
// appear post-onboarding when `preferredMedication` is still unset.
//
// Kept deliberately separate from the shared onboarding/insurance arrays
// (`WM_NEW_VALID_ONBOARDING_PRICE_POINTS`, `WM_INSURANCE_VALID_PRICE_POINTS`,
// etc.), which also drive sign-up plan selectors, coupon logic, appointment
// pickers and complete-profile gating — widening the widget's coverage here
// must not leak into those surfaces.
export const WM_PREFERRED_MEDICATION_PRICE_POINTS = [
  ...WM_INTRO_PROMO_PRICE_POINTS,
  ONE_MONTH_CARE_ONLY_PP, // wm-one-month-149
  'wm-insurance-one-month-29',
  'wm-maintenance-semaglutide-one-month',
  'wm-one-month-49',
  BUNDLE_WEGOVY_ONE_MONTH_PRICE_POINT,
  BUNDLE_WEGOVY_PILL_PRICE_POINT
];

// export const SEMAGLUTIDE_BENEFITS_PRICE_POINT = 'compound-semaglutide-one-month-249';
// export const WM_INSURANCE_ALT_VALID_PRICE_POINTS = ['wm-insurance-one-month-trial'];
